import { Sidebar } from "../../shared/components";
import { AuthGuard } from "../../shared/guards/AuthGuard";
import { FirePresentation } from "./components/FirePresentation";


export const FirePage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<FirePresentation />
			</Sidebar>
		</AuthGuard>
	);
};
